import { swalWithConfirmAndCancelButtons } from "components/custom/swal"
import React, { useEffect, useRef, useState } from "react"
import { userService } from "services/user.service"
import Loader from "react-loaders"
import { currencyFormatter } from "utils/formatters"
import { toast } from "react-toastify"
import moment from "moment"
import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap"
import api from "services/api.service"
import colors from "utils/colors"
import isNullOrEmpty from "utils/isNullOrEmpty"
import SyncfusionGrid from "components/custom/Syncfusion/SyncfusionGrid"

const ContractGrid = ({
  contracts,
  isLoading,
  enterprise,
  setContract,
  toggleEditModal,
  reloadData,
}) => {
  const currentUser = userService.getLoggedInUser()
  var gridRef = useRef(null)
  const [showActionsDropdown, setShowActionsDropdown] = useState(false)
  const [columns, setColumns] = useState([])

  useEffect(() => {
    if (
      contracts != undefined &&
      contracts != null &&
      contracts.length > 0 &&
      !isNullOrEmpty(enterprise)
    ) {
      setColumns(loadColumns())
    }
  }, [contracts, enterprise])

  const handleNamePress = (e, contract) => {
    e && e.preventDefault()
    setContract(contract)
    toggleEditModal()
  }

  const loadColumns = () => {
    return [
      {
        type: "checkbox",
        width: 50,
      },
      {
        headerText: enterprise.contractLabel + " #",
        field: "contractNumber",
        template: data => (
          <a href="#" onClick={e => handleNamePress(e, data)}>
            {data.contractNumber}
          </a>
        ),
      },
      {
        headerText: enterprise.contractLabel + " Name",
        field: "contractName",
      },
      {
        headerText: "Year",
        field: "contractYearID",
      },
      {
        headerText: "Funding Category",
        field: "fundName",
        filter: {
          type: "Excel",
          itemTemplate: data => {
            return (
              <div
                style={{ lineHeight: "20px" }}
                dangerouslySetInnerHTML={{
                  __html: data.fundName,
                }}
              ></div>
            )
          },
        },
        template: data => (
          <div
            style={{ lineHeight: "20px" }}
            dangerouslySetInnerHTML={{
              __html: data.fundName,
            }}
          ></div>
        ),
      },
      {
        headerText: "Total Amount",
        field: "contractAmount",
        textAlign: "Right",
        filter: {
          type: "Excel",
          itemTemplate: data => {
            return currencyFormatter.format(data.contractAmount)
          },
        },
        template: data => {
          return currencyFormatter.format(data.contractAmount)
        },
      },
      {
        headerText: "Allocation Amount",
        field: "contractAllocation",
        textAlign: "Right",
        filter: {
          type: "Excel",
          itemTemplate: data => {
            return currencyFormatter.format(data.contractAllocation)
          },
        },
        template: data => {
          return currencyFormatter.format(data.contractAllocation)
        },
      },
      {
        headerText: "Reversion Date",
        field: "reversionDate",
        type: "string",
        filter: {
          type: "Excel",
          itemTemplate: data => {
            return moment(data.reversionDate).isValid()
              ? moment(data.reversionDate).format("MM/DD/YYYY")
              : ""
          },
        },
        template: data => {
          return moment(data.reversionDate).isValid()
            ? moment(data.reversionDate).format("MM/DD/YYYY")
            : ""
        },
      },
    ]
  }

  const deleteSelected = () => {
    swalWithConfirmAndCancelButtons
      .fire({
        headerText: `Are you sure you want to delete the selected contracts?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      })
      .then(async result => {
        if (result.isConfirmed) {
          let selected = gridRef.current.getSelectedRecords()
          if (selected.length > 0) {
            let copy = [...selected]
            let tasks = copy.map(x => async () => {
              return await api.deleteContract(currentUser.userID, x.contractID)
            })
            await Promise.all(tasks.map(t => t()))
            reloadData()
            toast.success("Contracts deleted successfully")
          }
        }
      })
  }

  return (
    <React.Fragment>
      {isLoading && (
        <Loader
          type="line-scale-pulse-out"
          color={colors.primary}
          style={{ textAlign: "center" }}
        />
      )}
      {!isLoading && contracts.length > 0 && (
        <>
          <Row>
            <Col
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "end",
              }}
            >
            
              <Dropdown
                className="save-user"
                isOpen={showActionsDropdown}
                toggle={() => setShowActionsDropdown(!showActionsDropdown)}
              >
                <DropdownToggle
                  tag="button"
                  className="btn btn-sm btn-outline-primary"
                >
                  Actions <i className="mdi mdi-chevron-down" />
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => deleteSelected()}>
                    <i className="fas fa-trash-alt"></i> Delete{" "}
                    {enterprise?.contractLabel ?? "Contract"}s
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </Col>
          </Row>
          <div >
            {columns.length > 0 && (
              <SyncfusionGrid
                gridRef={gridRef}
                columns={columns}
                data={contracts}
                selectionSettings={{
                  type: "Multiple",
                  mode: "Row",
                  checkboxOnly: true,
                }}
              />
            
            )}
          </div>
        </>
      )}
    </React.Fragment>
  )
}

export default ContractGrid
